<template>
  <div style="background-color: #fff; height: 100%;">
    <div class="header_container">
      <van-row type="flex"  justify="space-between" style="height: 40px;">
        <van-row type = "flex" style ="margin:2px" >
          <div><van-image width="40px" :src =" logo"/></div>
          <div class="grid-content"  ><div>天津大学浙江研究院</div><div>实验室安全教育培训与管理系统</div></div>
        </van-row>
        <div>
        </div>
      </van-row>
      <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0', margin:'2px' }">
      </van-divider>
    </div>
    
    <!-- <van-form @submit="onSubmit">
      <van-field
        v-model="loginForm.usrName"
        name="用户名"
        label="用户名"
        placeholder="用户名"
        :rules="[{ required: true, message: '请填写用户名' }]"
      />
      <van-field
        v-model="loginForm.password"
        type="password"
        name="密码"
        label="密码"
        placeholder="密码"
        :rules="[{ required: true, message: '请填写密码' }]"
      />
      <div style="margin: 16px;">
        <van-button round style="width:50%" block type="info" native-type="submit">提交</van-button>
        <van-button round  style="width:50%" block type="info" native-type="submit">取消</van-button>
      </div>
    </van-form>
     -->
     <div style="height: calc(80vh - 120px); margin-top: calc(10vh); ">
      <div  class="aui-page__login" style="margin:20px">
        <div class="login-header" style="margin:auto;text-align: center;">
          <h2 class="login-brand">登录</h2>
        </div>
        <div class="login-body">
          <!-- <h3 class="login-title">{{ login.title }}</h3> -->
          <el-form :model="dataForm"  status-icon>
          <el-form-item label="选择登录方式:">
            <el-radio-group v-model="dataForm.radio" @input="changeStatus(dataForm.radio)">
              <el-radio :label="'3'">用户名密码</el-radio>
              <!-- <el-radio :label="'6'">短息认证码</el-radio> -->
            </el-radio-group>
          </el-form-item>
            <el-form-item prop="username">
              <el-input
                :placeholder="dataForm.placeholderOne"
                v-model="dataForm.username">
                <i slot="prefix" class="el-input__icon el-icon-user"></i>
              </el-input>
            </el-form-item>
            <el-form-item v-if="!dataForm.vertifyCodeFlag">
              <el-input
                :placeholder="dataForm.placeholderTwo"
                v-model="dataForm.password" show-password>
                <i slot="prefix" class="el-input__icon el-icon-lock"></i>
              </el-input>
            </el-form-item>
            <el-form-item v-else>
              <el-row :gutter="10">
                <el-col :span="14">
                  <el-input v-model="dataForm.vertifyCode" :placeholder="dataForm.placeholderThree">
                    <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                  </el-input>
                </el-col>
                <el-col :span="10">
                  <el-button type="primary"  :disabled="timer.tagTimerFlag" @click="sendVertifyCode()" >获取验证码</el-button>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="doLogin()" >登录</el-button>
              <el-button type="danger" @click="cancelSubmit()">取消</el-button>
              <el-tag type="primary" v-if ="timer.tagTimerFlag" >{{timer.seconds}}秒后重新获取</el-tag>
            </el-form-item>
          </el-form>
        </div>
        <div class="login-footer">
          <!-- <p>
            <a href="http://demo.open.renren.io/renren-security" target="_blank">12132</a>
          </p>
          <p><a href="https://www.renren.io/" target="_blank">12312321</a>2022 © renren.io</p> -->
        </div>
      </div >
     </div>
     
  </div>
 

</template>

<script>
  import {STORE_USER_INFO,TOKEN_ID} from '@/mutation/mutConst'
  import  SERVICE_URL from '@/api/url'
  import {stringIsNullOrEmpty} from  '@/api/utils'
  import {MESSAGE_DURATION } from  '@/api/constant'
  import axios from  '@/api/axiosConfig'
  import logo from "@/assets/image/yuanhui.png"
  export default {
    name : 'login',
    data () {
      return {
        logo,
        dataForm: {
        placeholderOne :"请输入用户名",
        placeholderTwo :"请输入密码",
        placeholderThree :"请输入验证码",
        username: '',
        password: '',
        vertifyCode :'',
        radio : "3",
        vertifyCodeFlag : false
      },
      timer:{
        timerId :'',
        seconds:'',
        multiSendTtl:'',
        tagTimerFlag : false
      },
      }
    },
    mounted () {
      this.showLogin = true;
      
    },
    methods: {
      async onSubmit (loginInfo) {
       let  url = "/bc/exa/usr/login"
        let data =JSON.parse(JSON.stringify(this.loginForm))
        axios.post(url, data).then((response) => {
          if (response.data.code === 0){
            this.$store.commit(TOKEN_ID, response.data.data.token)
            this.$router.push({path:'/mini_index'})
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch((err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
        })
      },
      cancelSubmit(){
      this.dataForm.username = ""
      this.dataForm.password = ""
      this.dataForm.vertifyCode = ""
    },
    changeStatus(val){
      if(val == 3){
        this.dataForm.vertifyCodeFlag = false
        this.dataForm.placeholderOne = "请输入用户名"
      }else{
        this.dataForm.vertifyCodeFlag = true
        this.dataForm.placeholderOne = "请输入手机号码"
      }
    },

    timerFunc(){
      const startTime = new Date()
      if(this.timer.seconds === ''){
        const timeTtl = (startTime.getTime()  + 1 * 1000 * 60 )
        this.timer.multiSendTtl = timeTtl
        this.timer.seconds = 60
        this.timer.tagTimerFlag = true
        return 
      }
      if(this.timer.seconds === 0){
        this.timer.seconds  = ''
        this.timer.multiSendTtl = ''
        this.timer.tagTimerFlag = false
        setTimeout(()=>{
          if(this.timer.timerId != '' ){
            clearInterval(this.timer.timerId)   
            this.timer.timerId = '' 
          }
        },200)
        return 
      }
      if( startTime.getTime() > this.timer.multiSendTtl){
        this.timer.seconds = 0;
        return 
      }
      let seconds  = this.timer.seconds  - 1
      if(seconds <= 0 ){
        this.timer.seconds == 0;
      }else{
        this.timer.seconds = seconds
      }
      
    },

    doLogin(){
      let dat = {};
      let url = "";
      try{
        if(this.dataForm.radio == 3){
          stringIsNullOrEmpty(this.dataForm.username, "用户名不能为空")
          stringIsNullOrEmpty(this.dataForm.password, "密码不能为空")
          url = "/bc/exa/usr/login"
          dat.usrName = this.dataForm.username,
          dat.password = this.dataForm.password
        } else{
          stringIsNullOrEmpty(this.dataForm.username, "用户名不能为空")
          stringIsNullOrEmpty(this.dataForm.vertifyCode, "验证码不能为空")
          url = "/bc/exa/usr/loginByPhoneCode"
          dat.phoneNo = this.dataForm.username,
          dat.phoneCode = this.dataForm.vertifyCode
        }
      }catch(e){
        this.$message({
          showClose: true,
          message:e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        return 
      }
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$store.commit(TOKEN_ID, response.data.data.token)
          this.$router.push({path:'/mini_index'})
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    sendVertifyCode(){
      let url = "/bc/exa/usr/sendPhoneCode"
      let dat = {
        phoneNo : this.dataForm.username
      }
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            this.timer.timerId = setInterval(this.timerFunc,1000)
            this.$message({
              showClose: true,
              message: '发送成功!',
              type: 'success',
              duration: MESSAGE_DURATION
            })
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch((err) => {
          this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
          }) 
      })
    },
    cancelSubmit(){
       this.dataForm.username=""
       this.dataForm.password=""
       this.dataForm.vertifyCode=""
    },
  },
  beforeRouteLeave(to, from, next){
    if (this.timer.timerId != '') {
      clearInterval(this.timer.timerId);
      this.timer.timerId = '';
    }
    this.cancelSubmit();
    next();
  },
  beforeDestroy(){
    if (this.timer.timerId != '') {
      clearInterval(this.timer.timerId);
      this.timer.timerId = '';
    }
  }
}
</script>

<style lang="less" scoped>
  .grid-content{
    margin-top: 4px;
    margin-left: 1px;
    text-align: center;
    font-weight: 700;
    color: #0162c3 ;
    font-size: 0.8em;
  }
</style>



// WEBPACK FOOTER //
// src/mini_pages/login.vue